import { useCallback } from 'react';

import screenTypeTelemetry from '../screenTypeTelemetry';

import { EMPLOYER_SCREENING_QUESTIONS } from '../../../screenTypeSchema';

export function useTelemetry(applyData) {
  const { logView, logInteraction, logFinish } = screenTypeTelemetry(EMPLOYER_SCREENING_QUESTIONS, applyData);
  const screenType = 'employer_screening_question';
  const screenViewName = 'employer_screening_question';

  return {
    logView: useCallback(({ questionNumber, totalQuestions }) => {
      logView({
        screen_type: screenType,
        screen_view_name: screenViewName,
        employer_screening_question_index: questionNumber,
        total_employer_screening_questions: totalQuestions,
      });
    }, [logView]),

    logInteraction: useCallback((interaction, { questionNumber, totalQuestions, completed }) => {
      logInteraction(interaction, {
        screen_type: screenType,
        screen_view_name: screenViewName,
        employer_screening_question_index: questionNumber,
        total_employer_screening_questions: totalQuestions,
        finished_screen_type: completed,
      });
    }, [logInteraction]),

    logFinish: useCallback(logFinish, [logFinish]),
  };
}

export default useTelemetry;
